export default {
  'article-page-test-h1':
    'sm:text-22 md:text-32 font-BebasNeueRegular sm:pt-40 md:pt-0',
  'safetyHeading': 'sm:text-22 md:text-32 font-BebasNeueRegular sm:pt-40 md:pt-0',
  'savewaterHeading': 'text-10v md:text-6v font-BebasNeueBold  md:pt-0 savewaterHeadingonetext',
  'anitarcHeading': 'text-6v md:text-3v font-HelveticaNeueBold md:pt-0 ',
  'anitacenterHeading': 'text-6v md:text-4v font-BornreadyRegular md:pt-0 my-20 ',
  'savewaterHeadingTwo': ' text-10v  md:text-6v font-BornreadyRegular md:pt-0 savewaterHeadingTwotext',
  'savewatervoicesabaHeading': 'text-6v text-left  md:text-32 font-BebasNeueBold text-1.5v sm:pt-40 md:pt-0',
  'savewaterSobreHeading': 'sm:text-8v font-BornreadyRegular md-w-12/12 md:text-4.6v sm:pt-40 md:pt-0 savewaterSobreHeading',
  'safetyHeadingtwo': 'sm:text-22 md:text-32 font-BebasNeueRegular sm:pt-40 md:pt-0',
  'story-heading-center':
    'text-35 leading-35 md:text-65 md:leading-65 font-BebasNeueRegular sm:pt-0 text-center nonoListHead md:text-left text-center',
  'story-heading-center-look':
    'sm:text-44 md:text-80 font-BebasNeueRegular sm:pt-0 text-center sm:-mb-20 md:-mb-40',
  'RecycleHeading': 'text-9v font-semibold md:font-normal md:text-5v md:py-1v font-BebasNeueRegular sm:pt-0 text-center sm:-mb-20 md:-mb-40 font-BornreadyRegular recycleHeadingtext',
  'RecycleHeadingTwo': 'text-10v font-BebasNeueBold sm:pt-0 text-center sm:-mb-20 md:-mb-40 md:text-5v',
  'article-page-test-h2':
    'sm:text-43 md:text-76 leading-normal font-BornreadyRegular article-title',
  'h2-80-center':
    'text-40 md:text-60 md:leading-60 sm:leading-40 text-center font-BornreadyRegular lowercase md:text-left text-center',
  'step-heading-80':
    'sm:text-43 md:text-80 leading-61 sm:text-left md:text-center font-BornreadyRegular ml-inside',
  'heading-article': 'headingarticlepurple',
  'ingredients-sub-heading':
    'text-18 sm:leading-20 lg:leading-24 text-black font-BebasNeueRegular tracking-wider pb-25 md:pb-15 lg:pr-30 md:min-h-63',
  'ingredients-sub-heading-prov':
    'text-22 sm:leading-20 lg:leading-24 text-black font-BebasNeueRegular tracking-wider3x pb-25 md:pb-15 lg:pr-20 md:min-h-63 text-center',
  'pantene-products-stands':
    'text-18 sm:leading-20 lg:leading-24 text-black font-BebasNeueRegular tracking-wider pb-25 md:pb-15 lg:pr-20 md:min-h-63',
  'article-detail-header2':
    'text-36 font-BornreadyRegular leading-48 sm:mt-20 lg:mt-0 mb-30 lg:mb-8 font-hairline sm:pl-70 sm:pr-20 lg:px-0 inline-block w-full',
  'power-of-grey-heading-one': 'power-of-grey-heading-one',
  'power-of-grey-heading-three': 'power-of-grey-heading-three',
  'power-of-hair-heading-35-h2':
    'font-BebasNeueRegular leading-36 text-35 font-bold tracking-2.1 mb-30 sm:pl-70 lg:pl-0',
  'grey-and-glowing-heading': 'grey-and-glowing-heading',
  'home-banner-h2':
    'sm:text-12v sm:mt-0 sm:p-0 md:p-0 md:text-48 font-BebasNeueRegular text-white sm:tracking-2.76 md:tracking-2.88',
  'home-section-h2':
    'sm:text-6.5v sm:mt-0 sm:p-20 sm:pt-0 md:p-0 md:text-36 font-BebasNeueRegular text-black tracking-wider3x leading-36 sm:leading-normal',
  'home-section-Bornready':
    'sm:text-9.5v sm:mt-0 sm:p-20 sm:pt-10 md:p-0 md:text-52 font-BornreadyRegular text-black md:pt-30 md:pb-30',
  'whats-new-section':
    'sm:text-9.5v sm:mt-0  sm:pt-31 sm:pb-12 md:p-0 md:text-52 font-BornreadyRegular text-black md:pb-20',
  'home-section-Bornready-pb':
    'sm:text-9.5v sm:mt-0 sm:p-0 sm:pt-30 sm:pb-10 md:p-0 md:text-52 font-BornreadyRegular text-black md:pb-10 whatsindside',
  'home-section-Bornready-52':
    'sm:text-9.5v sm:mt-0 md:mt-10 sm:p-20 md:p-0 md:text-52 font-BornreadyRegular text-center text-black md:pb-40 md:pt-10 font-normal md:leading-28 md:tracking-1.56',
  'home-section-BebasNeueRegular-52':
    'sm:text-9.5v md:text-52 font-BebasNeueRegular md:pt-0 text-center gradient-text md:pt-80 pb-30',
  'home-section-BebasNeueRegular-50':
    'sm:text-13v md:text-45 sm:py-10 font-BebasNeueRegular sm:text-center md:text-left gradient-text md:py-12',
  'home-section-BebasNeueRegular-new':
    'sm:text-6.5v md:text-30 sm:py-10 font-BebasNeueRegular sm:text-center md:text-left gradient-text md:py-12',
  'prov-section-BebasNeueRegular-50':
    'sm:text-13v md:text-40 sm:py-10 font-BebasNeueRegular sm:text-center md:text-left gradient-text md:py-12',
  'prov-section-BebasNeueRegular-50-new':
    'sm:text-13v md:text-40 sm:py-10 font-BebasNeueBold text-center gradient-text md:py-12',
  'prov-section-BornreadyRegular-50':
    'sm:text-13v md:text-40 sm:py-10 font-BornreadyRegular sm:text-center md:text-left gradient-text md:py-12',
  'home-section-h3-24':
    'sm:text-6.5v sm:my-0 sm:px-20 sm:py-0 md:p-0 md:text-24 font-BebasNeueRegular text-black md:pb-0 tracking-0.67 sm:tracking-1.8',
  'home-section-best':
    'sm:text-6.5v sm:my-0 sm:px-20 sm:py-10 sm:pb-20 md:p-0 md:text-24 font-BebasNeueRegular text-black md:pb-0 tracking-0.67 sm:tracking-1.8',
  'home-section-h2-36':
    'sm:text-6.5v sm:mt-0 sm:p-15 md:p-0 md:text-36 font-BebasNeueRegular text-black md:pb-18 md:pt-15 md:pb-0 sm:leading-normal',
  'home-section-gradient':
    'sm:text-6.5v md:text-20 font-BebasNeueRegular md:pt-0',
  'hair-biology-heading':
    'headingStyle text-40 lg:text-65 font-BornreadyRegular text-black leading-68 lg:leading-110 font-hairline tracking-2.92 w-full mdp:w-6/12',
  'heading-gradient-underline-28-center-pb':
    'font-BebasNeueRegular text-28 md:leading-30 md:tracking-0.84 sm:font-normal md:font-bold sm:pt-5 sm:mb-34 md:mb-44 text-center gradient-underline gradient-center',
  'heading-gradient-underline-28-center-24':
    'font-BebasNeueRegular text-28 md:leading-30 sm:tracking-0.84 md:tracking-0.84 sm:font-normal md:font-bold sm:pt-5 sm:mb-24 md:mb-24 text-left gradient-underline gradient-center',
  'heading-pantene-hair-68-center':
    'font-BebasNeueRegular sm:text-58 md:text-68 sm:tracking-1.74 md:tracking-2.04 text-center',
  footerMobileHeader:
    'font-BebasNeueRegular footerMobileHeader md:pb-25 sm:text-18 footer-accordian-header',
  powerOfHairParaHeading:
    'font-BebasNeueRegular text-black text-20 pb-5 sm:pl-70 sm:pr-15 lg:px-0 leading-normal',
  'unidas-story-heading-center':
    'sm:text-40 md:text-70 font-BebasNeueBold sm:pt-0 text-center sm:mb-20 md:-mb-40 golbBGUnidas',
  'story-heading-center-nono1':
    'md:text-65 md:leading-65 text-36 leading-36 font-BebasNeueRegular pt-0 nonoListHead',
  'h2-80-center-nono':
    'md:text-65 md:leading-70 text-40 leading-40 font-BornreadyRegular',
  EssentialHeading: 'font-BebasNeueBold text-black nossosHeading md:text-70 md:leading-70 text-50 leading-50 md:mt-0 mt-20',
  EssenciaisHeadingTwo: 'font-BornreadyRegular lowercase essenciaisHeadingTwo md:mb-0 mb-20',
  NossoHeading: 'font-BebasNeueBold font-normal text-8v md:text-4v w-full block Nossoheadingsub ',
  ManifestoHeadingStyle: 'my-10 md:mt-0 md:mb-20 text-2.3vw font-semibold Manifestoheading font-BebasNeueBold',
  safetyHeadingMain: 'font-BebasNeueBold text-black text-30 leading-30 md:text-60 md:leading-60 safetyHeadingMain md:p-20 pt-20 px-20',
  anitaHeadingMain: 'font-BebasNeueBold text-black text-30 leading-30 md:text-60 md:leading-60 safetyHeadingMain pt-0 md:pt-20 lg:pt-20; ',
  ProvHeadingRichtext: 'w-full md:w-6/12 text-20 sm:leading-20 lg:leading-30 text-black font-BebasNeueRegular tracking-wider lg:mr-30 ProvHeadingRichtext mb-30 md:mb-0',
  'nuvasprovheading': 'text-25 md:text-46 leading-40 md:leading-61 text-left font-normal gradient-text font-BornreadyRegular ml-inside tedamosText capitalize',
  'vita-landing-ingredients-title': 'viewAllButton font-BebasNeueRegular text-20 lg:text-22 leading-30 tracking-wider text-center gradient-line',
};
